//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const length = ref(5)
    const rating = ref(2)

    return {
      length,
      rating,
    }
  },
}
